import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
export var Icon = AwsUi.__addComponent('awsui-icon', {
    releaseStatus: 'stable',
    properties: {
        // Size of the icon.
        size: {
            type: 'string',
            valid: ['normal', 'big', 'large'],
            defaultValue: 'normal'
        },
        // Color variant of the icon. Please mind that the normal variant picks up the current color
        // of its context.
        variant: {
            type: 'string',
            valid: ['normal', 'disabled', 'error', 'inverted', 'link', 'subtle', 'success', 'warning'],
            defaultValue: 'normal'
        },
        // The icon to be displayed.
        name: {
            type: 'string',
            valid: [
                'add-plus',
                'angle-down-double',
                'angle-down',
                'angle-left-double',
                'angle-left',
                'angle-right-double',
                'angle-right',
                'angle-up-double',
                'angle-up',
                'bug',
                'call',
                'calendar',
                'caret-down-filled',
                'caret-down',
                'caret-left-filled',
                'caret-left',
                'caret-right-filled',
                'caret-right',
                'caret-up-filled',
                'caret-up',
                'contact',
                'close',
                'copy',
                'download',
                'edit',
                'envelope',
                'expand',
                'external',
                'file-open',
                'file',
                'filter',
                'folder-open',
                'folder',
                'heart',
                'help',
                'key',
                'lock-private',
                'menu',
                'microphone',
                'notification',
                'refresh',
                'search',
                'settings',
                'share',
                'status-in-progress',
                'status-info',
                'status-negative',
                'status-pending',
                'status-positive',
                'status-stopped',
                'status-warning',
                'treeview-collapse',
                'treeview-expand',
                'undo',
                'unlocked',
                'upload',
                'view-full',
                'view-horizontal',
                'view-vertical',
                'zoom-in',
                'zoom-out'
            ]
        },
        // Alternate text for the custom icon, please provide this for accessibility reasons.
        // This property is not taken into account by the predefined icon set.
        alt: {
            type: 'string',
            defaultValue: ''
        },
        // URL of the custom icon. Use this property if the icon you want is not available.
        url: {
            type: 'string'
        }
    },
    render: function (m, h) {
        var cb = new LegacyClassBuilder(this);
        cb.addClass('awsui-icon')
            .addPropertyValueClass('size')
            .addPropertyValueClass('variant');
        // eslint-disable-next-line no-undef
        var icon = this.name ? require("./icons/" + this.name) : '';
        var svg = h.unsafelyCreateElementFromString(icon);
        var img = AwsUi.__createElement("img", { src: this.url, alt: this.alt });
        return AwsUi.__createElement("span", { className: cb.toClassName() }, this.url ? img : svg);
    }
});
//# sourceMappingURL=index.js.map